module.exports = __webpack_public_path__ + "img/download-pdj-big-active.9f1bf2c7.png";